import { useEffect } from "react";

const useGoogleAnalytics = (measurementId) => {
  useEffect(() => {
    if (!window.gtag) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', measurementId);
      };
    }
  }, [measurementId]);

  const trackEvent = (buttonName) => {
    const eventData = {
      event_category: "User Interaction",
      event_label: `Clicked ${buttonName} Button`,
      value: 1,
    };

    if (window.gtag) {
      window.gtag("event", "button_clicked", {
        event_category: eventData.event_category,
        event_label: eventData.event_label,
        value: eventData.value,
        button_name: buttonName,
      });
    }
  };

  return trackEvent;
};

export default useGoogleAnalytics;
